import { FormControl } from '@angular/forms';
import { positiveNotNull, positiveOrZero, requiredNotNull } from '../form-control-options.constants';
import { BaseFormControls } from './base.form-controls';

export class ShoppingItemFormControls extends BaseFormControls {
  amount = new FormControl(1, positiveNotNull);
  bestBeforeDate = new FormControl<Date | null>(new Date());
  date = new FormControl(new Date(), requiredNotNull);
  neverOverdue = new FormControl(true, requiredNotNull);
  pantIncluded = new FormControl(false, requiredNotNull);
  purchaseQuPant = new FormControl<number | null>(null, positiveOrZero);
  purchaseQuPrice = new FormControl<number | null>(null, positiveOrZero);
  totalDiscount = new FormControl<number | null>(null, positiveOrZero);
  totalPrice = new FormControl<number | null>(null, positiveOrZero);
}
